export const Running = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.286 9.71322L22.9685 15.9982L16.2725 9.3052C15.8814 8.91429 15.2473 8.91497 14.8571 9.30671L8.70703 15.4804" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M14.6733 27.3662L21.0049 21.0346L16.0198 16.0169L2.72493 29.3118" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="22.5" cy="5.5" r="2.5" stroke="currentColor" stroke-width="2"/>
</svg>`;
